import "../styles/downloadButton.css";
import React from "react";

import { toPng } from "html-to-image";
import { jsPDF } from "jspdf";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

function DownloadButton(props) {
  const downloadPNG = async () => {
    const element = document.querySelector(".house-components");

    if (!element) {
      console.error("Could not find .house-components");
      return;
    }

    try {
      const dataUrl = await toPng(element, {
        cacheBust: true,
        backgroundColor: "#ffffff",
        pixelRatio: 2,
      });

      const link = document.createElement("a");
      link.download =
        `${props.governmentBody}-static-diagram.png`.toLowerCase();
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error("Error creating PNG:", error);
    }
  };

  const downloadPDF = async () => {
    const element = document.querySelector(".house-components");

    if (!element) {
      console.error("Could not find .house-components");
      return;
    }

    try {
      const dataUrl = await toPng(element, {
        cacheBust: true,
        backgroundColor: "#ffffff",
        pixelRatio: 2,
      });

      const img = new Image();

      img.onload = () => {
        const pdf = new jsPDF({
          orientation: img.width > img.height ? "landscape" : "portrait",
          unit: "px",
          format: [img.width, img.height],
        });

        pdf.addImage(dataUrl, "PNG", 0, 0, img.width, img.height);

        pdf.save(`${props.governmentBody}-static-diagram.pdf`.toLowerCase());
      };

      img.src = dataUrl;
    } catch (error) {
      console.error("Error creating PDF:", error);
    }
  };

  return (
    <div className="download-btn-container">
      <DropdownButton
        align="end"
        title="Static Diagram"
        className="download-btn"
      >
        <Dropdown.Item className="dropdown-btn-item" onClick={downloadPNG}>
          {" "}
          <span class="material-symbols-outlined download-icon">download</span>
          Download as .png
        </Dropdown.Item>
        <Dropdown.Item className="dropdown-btn-item" onClick={downloadPDF}>
          {" "}
          <span class="material-symbols-outlined download-icon">download</span>
          Download as .pdf
        </Dropdown.Item>
      </DropdownButton>
    </div>
  );
}

export default DownloadButton;
